import { Link } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';

export default function NotFound() {
  return (
    <SiteLayout>
      <section className="flex w-full flex-col items-center justify-center px-4 py-24 text-center md:py-32">
        <p className="font-label text-6xl tracking-[0.2em] text-primary-500/30 md:text-8xl">404</p>
        <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          这卷胶片没有找到
        </h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-400">
          你访问的页面不存在，可能链接输入有误或内容已经调整。可以回到首页，或者从下面的入口继续浏览。
        </p>
        <div className="mt-7 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-400"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
          <Link
            to="/story"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300/70 px-5 py-2.5 text-sm text-foreground-300 transition-colors hover:border-primary-500/50 hover:text-primary-300"
          >
            剧情介绍
          </Link>
          <Link
            to="/search"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300/70 px-5 py-2.5 text-sm text-foreground-300 transition-colors hover:border-primary-500/50 hover:text-primary-300"
          >
            站内搜索
          </Link>
        </div>
      </section>
    </SiteLayout>
  );
}